<template>
    <div>

        <form id="" @submit.prevent="addShiftData">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Add Shift </h1>
                <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Save</button>
                <router-link to="/shifts" class="btn btn-primary float-right mr-1"> Cancel </router-link>
            </div>
            <div class="shifts-main">
                <div class="tab-content-inner">
                    <div class="row normal-ib-space">
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Shift Name <em class="required">*</em> </label>
                                <input type="text" class="form-control" v-model="form.name" name="name" placeholder="" id="name" autocomplete="off" :class="{ 'is-invalid': form.errors.has('name') }"/>
                                <has-error :form="form" field="name"></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Weekly Hours <em class="required">*</em> </label>
                                <input type="number" class="form-control" v-model="form.weekly_hours" name="weekly_hours" placeholder="" id="weekly_hours" autocomplete="off" :class="{ 'is-invalid': form.errors.has('weekly_hours') }"/>
                                <has-error :form="form" field="weekly_hours"></has-error>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                                <label>Overtime <em class="required">*</em></label>
                                <select v-model="form.overtime" name="overtime" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('overtime') }">
                                    <option value="DISABLED"> Disabled</option>
                                    <option value="ENABLED"> Enabled</option>>
                                </select>
                                <has-error :form="form" field="overtime"></has-error>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group" id="overtime_wage">
                                <label>hour(x<span class="red-text">*</span> </label>
                                <input type="number" class="form-control" v-model="form.overtime_wage" :disabled="form.overtime=='DISABLED'" step="0.1" name="overtime_percentage" placeholder="1" id="overtime_percentage" autocomplete="off" :class="{ 'is-invalid': form.errors.has('overtime_percentage') }"/>
                                <has-error :form="form" field="overtime_percentage"></has-error>
                            </div>
                        </div>

                    </div>

                    <div class="shifts-row mb-3" v-for="(day, index) in days">
                        <label class="check-holder mb-3">
                            {{day}}
                            <input :id="day" class="checkbox" type="checkbox" v-model="form.selectedDays" :value="day" :true-value="day">
                            <span class="checkmark"></span>
                        </label>
                        <div class="row normal-ib-space">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <select name="start_hrs[]" :id="day+'_'+index" v-model="form.start_hrs" @change="startTime(day,index,$event)" class="selectpicker custom-select2" disabled>
                                        <option value="default"> Start Time </option>
                                        <option v-for="n in 13" :value="n">{{n}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-1">
                                    <div class="form-group">
                                        <select name="start_mins" v-model="form.start_mins" id="start_mins" class="selectpicker custom-select2" disabled>
                                            <option value="default"> Mins </option>
                                            <option v-for="(n, index) in 60" :value="index">{{index}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <select name="start_ampm" v-model="form.start_ampm" id="start_ampm" class="selectpicker custom-select2" disabled>
                                            <option value="default"> Start Time </option>
                                            <option value="AM"> AM </option>
                                            <option value="PM"> PM </option>

                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <select name="start_grace_mins" v-model="form.start_grace_mins" id="start_grace_mins" class="selectpicker custom-select2" disabled>
                                            <option value="default"> Grace min </option>
                                            <option v-for="(n, index) in 60" :value="index">{{index}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <select name="end_hrs" v-model="form.end_hrs" id="end_hrs" class="selectpicker custom-select2" disabled>
                                            <option value="default"> End Time </option>
                                            <option v-for="(n, index) in 13" :value="n">{{n}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <select name="end_mins" v-model="form.end_mins" id="end_mins" class="selectpicker custom-select2" disabled>
                                            <option value="default"> Mins </option>
                                            <option v-for="(n, index) in 60" :value="index">{{index}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="form-group">
                                        <select name="end_ampm" v-model="form.end_ampm" id="end_ampm" class="selectpicker custom-select2" disabled>
                                            <option value="default">End Time</option>
                                            <option value="AM"> AM </option>
                                            <option value="PM"> PM </option>

                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <div class="form-group">
                                        <select name="end_grace_mins" v-model="form.end_grace_mins" id="end_grace_mins" class="selectpicker custom-select2" disabled>
                                            <option value="default"> Grace min </option>
                                            <option v-for="(n, index) in 60" :value="index">{{index}}</option>
                                        </select>
                                    </div>
                                </div>
                        </div>
                    </div>

                    </div>
                </div>

        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    'name': null,
                    'weekly_hours': null,
                    'overtime': 'DISABLED',
                    'overtime_wage': null,
                    'selectedDays': [],

                    'start_hrs': [],
                    'start_mins': [],
                    'start_ampm': [],
                    'start_grace_mins': [],
                    'end_hrs': [],
                    'end_mins': [],
                    'end_ampm': [],
                    'end_grace_mins': [],
                }),
                days:['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY','SUNDAY'],
            }
        },
        mounted(){
            // $(this.$el).find('.selectpicker').selectpicker('refresh');
            $('.checkbox').on('change', function(){
                if($(this).prop("checked") == true){
                    $(this).parents('.shifts-row').find('.selectpicker').attr('disabled', false);
                   $(this).parents('.shifts-row').find('.selectpicker').selectpicker('refresh');
                }
                else if($(this).prop("checked") == false){
                    $(this).parents('.shifts-row').find('.selectpicker').attr('disabled', true).val('default');
                    $(this).parents('.shifts-row').find('.selectpicker').selectpicker('refresh');
                }
            })
        },
        methods: {
            startTime(day,index,event){
                var id = day+'_'+index;
                this.form.start_hrs.push(event.target.value);

            },
            enableDisable(check,id){
            },
            addShiftData() {
                this.$Progress.start();
                this.form.post('api/addShift')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Shift created successfully'
                        });
                        this.$router.push('/shifts');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
        },
        created() {
        },
    }
</script>
